<template>
    <div>
        <div class="columns extra-pad pad-fix">
            <div class="column grey-back">
                <!-- <h1 class="scoring-h1">{{compname}}</h1> -->
                <h2 class="scoring-h2">Spectators</h2>
                <p class="buttons">
                    <b-button @click="$router.push(`/${compkey}/live`)" class="is-fullwidth" size="is-large" type="is-info">Live Scoreboard</b-button>
                    <b-button class="is-fullwidth" size="is-large" type="is-info">Results</b-button>
                </p>
            </div>
            <div v-if="reg" class="column white-back">
                <h2 class="scoring-h2">Competitors</h2>
                <p v-if="!isAuthenticated" class="buttons">
                    <b-button @click="$router.push(`/${compkey}/register`)" class="is-fullwidth" size="is-large" type="is-info">Register to Compete</b-button>
                    <b-button @click="$router.push(`/${compkey}/login`)" class="is-fullwidth" size="is-large" type="is-info">Login</b-button>
                </p>
                <p v-else class="buttons">
                    <b-button @click="$router.push(`/${compkey}/compete`)" class="is-fullwidth" size="is-large" type="is-info">Enter My Scores</b-button>
                    <b-button @click="logout" class="is-fullwidth" size="is-large" type="is-info">Logout</b-button>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CompetitorOptions',
    props: ['reg', 'compkey', 'compname'],
    mounted() {
        this.$store.dispatch('scoring/set_prev_route',{})
    },
    computed: { 
        isAuthenticated() {
            return this.$store.getters['account/isAuthenticated']
        },
    },
    methods: {
        logout() {
            this.$store
            .dispatch('account/logout')
            .then(response => {
                console.log(response)
                this.$emit('loggedout')
                this.$router.push('/')
                this.$buefy.toast.open({
                    message: 'You have been logged out',
                    type: 'is-info'
                })
            })
            .catch(error => {
                this.error = error.data;
            });

        }
    }
}
</script>

